// based on rc-tooltip 3.7.3
import Tooltip from './Tooltip'

export default Tooltip



// WEBPACK FOOTER //
// ./components/vc-tooltip/index.js